<template>
  <b-row class="item-details-container ">
     <b-col>
        <a  :href="'#item-details-'+productlist.id" draggable="false" class='wrapper-a' @click="clickToExpanding" >
          <b-list-group-item>
            <b-row>
              <b-col class="px-0" cols="2" sm="1">
                <div class="toggle-icon"  @click.prevent>
                  <span v-if="isVisible" aria-hidden="true"><b-icon variant="secondary" icon="caret-right-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                  <span v-else aria-hidden="true"><b-icon variant="secondary" icon="caret-down-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                </div>
              </b-col>
              <b-col class="pl-0" cols="7" sm="9">
                  <b-form-input v-model="updPL.name" @change="updateProductList()"></b-form-input>
              </b-col>
              <b-col cols="1" class="pl-0 ml-0">
                <b-form-checkbox v-model="activeProductList" switch @input="updateProductList()">
                  <span v-if="updPL.active==true">Active</span>
                  <span v-else>Inactive</span>
                </b-form-checkbox>
              </b-col>
              <!-- <b-col cols="1">
                <a :href="'#'+$route.path">
                  <b-icon icon="x-circle" variant="danger" font-scale="2.5" v-b-popover.hover.right="'Delete Product List'" @click="confirmPLDelete"></b-icon>
                </a>
              </b-col> -->
            </b-row>

            <b-collapse
            class="category-card"  v-model="isVisible"
             :id="'item-details-'+productlist.id">
              <b-row class="py-2">
                <b-col>
                  <h5 style="text-align: center;">Location - Schedule</h5>
                </b-col>
              </b-row>
              <PLLocations
                v-for="location of productlist.locations"
                v-bind:location="location"
                v-bind:key="location.id"
                :productlist="productlist"
                @emit-switch-overlay="emitSwitchOverlay"
                @emit-fetch-productlists="emitFetchProductLists">
              </PLLocations>
              <b-row class="mt-5">
                <b-col>
                  <h5 style="text-align: center;">Items</h5>
                  <b-list-group>
                      <PLItems
                        v-for="plitem of plitems"
                        v-bind:plitem="plitem"
                        v-bind:key="plitem.id"
                        :productlist_id="productlist.id"
                        @emit-remove-pl-item="removePLItem">
                      </PLItems>
                    <!-- Datalist searching for items to add to category -->
                    <b-list-group-item>
                      <b-form-input v-model="plname" :list="'item-list'+productlist.id" placeholder="Search for item" @input="fetchSearchItems()" @change="addPLItem()"></b-form-input>
                      <datalist :id="'item-list'+productlist.id">
                        <option v-for="item in items" :key="item.id">{{ item.name }}</option>
                      </datalist>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
              <b-row class="py-2">
                <b-col>
                  <b-button class="mb-2" variant="outline-dark" @click="specialUpdateProductList('copy')">Copy List</b-button>
                  <b-form-select style="float:left;" v-model="copylist" :options="allLists" value-field="id" text-field="name"></b-form-select>
                </b-col>
                <!-- <b-col>
                  <b-form-select style="float:left;" v-model="copylist" :options="allLists" value-field="id" text-field="name"></b-form-select>
                </b-col> -->
                <b-col>
                  <b-button variant="outline-dark" style="float: left;" @click="specialUpdateProductList('mass')">Add All Items</b-button>
                </b-col>
                <b-col >
                  <b-button variant="outline-danger" style="float: left;" @click="confirmClearProductListItems()">Clear All Items</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-list-group-item>
        </a>
     </b-col>
  </b-row>
</template>
<script>
import PLItems from '@/components/PLItems.vue'
import PLLocations from '@/components/PLLocations.vue'
export default {
  name: 'PLList',
  components: {
    PLItems,
    PLLocations
  },
  props: ['productlist','productlists'],
  data () {
    return {
      updPL: {
        name: this.productlist.name,
        active: this.productlist.active
      },
      confirmDel: '',
      plitems: [],
      totalplitems: '',
      items: [],
      plname: '',
      copylist: 0,
      allLists: this.productlists,
      urlext: '',
      isVisible: false ,
    }
  },

  computed: {
    
    activeProductList: {
      get: function() {
        return this.productlist.active;
      },
      set: function(newVal) {
        this.updPL.active = newVal;
      }
    },

    namefilter: function() {
      if (this.plname != '') {
        return '&name='+this.plname;
      } else {
        return '';
      }
    },

    listItems: function() {
      if (this.plitems.length > 0) {
        return this.plitems.map(plitem => plitem.id);
      } else {
        return [];
      }
    },
  },

  methods: {
     clickToExpanding(event){
      const currentIsVisible = this.isVisible ;
      const clickedTag = event.target.tagName ;
      if(clickedTag.includes('SPAN') || clickedTag.includes('LABEL') || (clickedTag.includes('INPUT') && event.target.type === 'checkbox' ))
      {
        return ;
      }
      else if(clickedTag.includes('INPUT')|| clickedTag.includes('BUTTON')||clickedTag.includes('SELECT') || ( clickedTag.includes('svg') && (event.target.classList[0] === "bi-x-circle")))
      {
         event.preventDefault();
        this.isVisible = currentIsVisible ;
      }
      else{
        event.preventDefault();
        this.isVisible = !currentIsVisible;
      }
      
    },
    emitFetchProductLists() {
      this.$emit('emit-fetch-productlists');
    },

    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    confirmClearProductListItems() {
      // Get a confirmation before deleting
      var confirmClr = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to remove all items from the Product List!', {
        title: 'Please confirm clear',
        centered: true
      })
      // Confirmed - you can delete the category now!
      .then(value => {
        confirmClr = value
        if (confirmClr == true) {
          this.clearProductListItems();
        }
      })
      // Error processing modal
      .catch(err => {
        console.log('an error has occurred. '+ err)
      })
    },

    async clearProductListItems() {
      var emptyplitems = [];
      await this.updateProductList(emptyplitems);
      this.retrievePLItems();
    },

    async specialUpdateProductList(type) {
      var urlext = '';
      if (type=='copy') {
        urlext = '?copyfrom='+this.copylist;
      } else if (type=='mass') {
        urlext = '?insertall=True';
      }
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("productlists/"+this.productlist.id+urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      if (data.success == true) {
        this.retrievePLItems();
        this.emitSwitchOverlay(false);
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the prodict list, please try again later.', {
          title: 'Error updating product list',
          centered: true
        })
      }
    },

    async retrievePLItems() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      // Check to see if there items associated with this Category?
      const { data } = await this.$api.get('productlists/'+this.productlist.id+'/items?active=True', {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      if (data.success == true) {
        this.plitems = data.items;
        this.totalplitems = data.total_items;
        this.emitSwitchOverlay(false);
      }
    },

    async confirmPLDelete() {
        // Check to see if there items associated with this Category?
        const { data } = await this.$api.get('productlists/'+this.productlist.id+'/items');
        if (data.success == true) {
          if (data.total_items > 0) {
            // If yes, give them this message
            this.$bvModal.msgBoxOk('There are Items associated with this List. Please remove them before deleting, or consider setting Product List to Inactive.', {
              title: 'Unable to Delete',
              centered: true
            })
          } else {
            // if not, get a confirmation before deleting
            this.confirmDel = ''
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete list '+this.productlist.name+'!', {
              title: 'Please confirm delete',
              centered: true
            })
            // Confirmed - you can delete the category now!
            .then(value => {
              this.confirmDel = value
              if (this.confirmDel == true) {
                this.deleteProductList();
              }
            })
            // Error processing modal
            .catch(err => {
              console.log('an error has occurred. '+ err)
            })
          }
        } else {
          // Error retrieving category-items
          this.$bvModal.msgBoxOk('There was a problem with this process, please try again later.', {
            title: 'Unspecified error',
            centered: true
          })
        }
    },

    async deleteProductList() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('productlists/'+this.productlist.id,
        config
      );
      if (data.deleted == true) {
        this.emitFetchProductLists();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the product list, please try again later.', {
          title: 'Error deleting product list',
          centered: true
        })
      }
    },

    async updateProductList(list_items=this.listItems) {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.updPL.name,
        "active": this.updPL.active,
        "list_item": list_items
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('productlists/'+this.productlist.id,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchProductLists();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the product list, please try again later.', {
          title: 'Error updating product list',
          centered: true
        })
      }
    },

    async fetchSearchItems() {
      // this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("items?active=True"+this.namefilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.items = await data.items;
      // this.emitSwitchOverlay(false);
    },

    async addPLItem() {
      this.emitSwitchOverlay(true);
      const res = this.items.filter(i => i.name == this.plname);
      var list_items = this.listItems;
      list_items.push(res[0].id);

      await this.updateProductList(list_items);
      this.retrievePLItems();
      this.plname = '';
    },

    async removePLItem(plitem_id) {
      this.emitSwitchOverlay(true);
      var list_items = this.listItems;
      list_items.splice (list_items.indexOf(plitem_id), 1);

      await this.updateProductList(list_items);
      this.retrievePLItems();
    },
  },

  created: function() {
    this.retrievePLItems();
  }
}
</script>

<style scoped>
 .toggle-icon{
   margin : 6px 5px;
 }
  .wrapper-a{
    text-decoration: none;
    color: initial;
  }
  .wrapper-a:hover{
    text-decoration: none;
    color: initial;
  }
  .list-group-item{
    position: relative;
    border: 0.2px solid rgb(238, 238, 238) ;
    margin: 10px 0px;
    border-radius: 6px;
    box-shadow: 0 1px 0px rgb(84 70 35 / 15%), 0 0px 2px 0px rgb(84 70 35 / 15%);
  }
  .list-group-item:hover{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%); 
  }
 
  .item-details-container > .col{
    padding: 0px;
  }
  .draggable-btn{
    position: relative;
    margin: auto 0px;
    cursor: pointer;
  }
  .draggable-btn > * {
    transform: rotateZ(270deg);
  }
  .form-control{
    outline: none;
    border-inline: none;
    border: none;
  }
  .form-control:focus{
    border-color: gray;
    box-shadow: 0 0 0px 1px rgb(109 109 109 / 25%);
    background-color: transparent;
    outline: 0;
  }
</style>
